import { useMemo } from 'react';
import Iconify from 'src/components/iconify';
import useContactUsHref from 'src/hooks/use-contact-us-href';
import { paths } from 'src/routes/paths';
import { CONTACT_SECTION_HASH } from 'src/utils/contact-us';

// ----------------------------------------------------------------------

export const NAV_ITEM_KEYS = {
  home: 'home',
  faqs: 'faqs',
  contact: 'contact',
};

// Home page section ids, in document order. Add a new section's id here to
// have it tracked in the URL hash and the nav's active state.
export const HOME_SECTION_IDS = ['home', 'about-us', 'faqs', 'contact-us'];

export const navConfig = [
  {
    key: NAV_ITEM_KEYS.home,
    title: 'Home',
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: '/#home',
  },
  {
    key: NAV_ITEM_KEYS.faqs,
    title: 'FAQs',
    path: '/#faqs',
    icon: <Iconify icon="akar-icons:question-fill" />,
  },
  {
    key: NAV_ITEM_KEYS.contact,
    title: 'Contact Us',
    path:'/#contact-us',
    icon: <Iconify icon="mdi:contact" />,
  },
];

/**
 * Main-layout nav config with Contact Us path resolved for the current page.
 */
export function useNavConfig() {
  const contactHref = useContactUsHref();

  return useMemo(
    () =>
      navConfig.map((item) =>
        item.key === NAV_ITEM_KEYS.contact ? { ...item, path: contactHref } : item
      ),
    [contactHref]
  );
}
